export default __webpack_public_path__ + "static/media/slide2.24b5250d.jpg";